const plusRegEx = new RegExp('\\+', 'g');
const forwardSlashRegEx = new RegExp('/', 'g');
const dashUnderScoreRegEx = new RegExp('-_', 'g');

/**
 *
 * This function converts the EWSId to OdataId by replacing the +, / with _,-
 * and any consecutive sequence of /+ with empty string.
 *
 */

export default function convertEwsIdToOdataId(itemId: string): string {
    return (
        itemId &&
        itemId
            .replace(plusRegEx, '_')
            .replace(forwardSlashRegEx, '-')
            .replace(dashUnderScoreRegEx, '')
    );
}
